import { FC, useCallback } from 'react';
import { useWorkspaceMenu } from './useWorkspaceMenu';
import { CustomDropdownMenu } from './CustomDropdownMenu/CustomDropdownMenu';
import { WorkspaceMenuProps } from './WorkspaceMenu.types';

export const WorkspaceMenu: FC<WorkspaceMenuProps> = ({
  trigger,
  items,
  headerItem,
  footerItem,
  defaultSelectedId,
  onSelect,
  beforeSelect = () => true,
  onSearchTermChange,
  showSearch,
  onOpenedChange,
  isOpened,
  ...rest
}) => {
  const { footer, searchBar, onOpenChange, selectedId, setSelectedId } = useWorkspaceMenu({
    items,
    footerItem,
    showSearch,
    onSearchTermChange,
    defaultSelectedId,
    onSelect,
  });

  const handleSelect = useCallback(
    // TODO: Provide explicit types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (id: any) => {
      if (typeof beforeSelect !== 'function') {
        console.error('beforeSelect should be a function');
      } else if (beforeSelect(id)) {
        setSelectedId(id);
      }
    },
    [beforeSelect, setSelectedId]
  );

  const handleOpenChange = useCallback(
    (open: boolean) => {
      onOpenedChange?.(open);
      onOpenChange?.(open);
    },
    [onOpenedChange, onOpenChange]
  );

  return (
    <CustomDropdownMenu
      onOpenedChange={handleOpenChange}
      isOpened={isOpened}
      data-test="workspace-menu"
      selectedId={selectedId}
      onSelect={handleSelect}
      searchBar={searchBar}
      header={headerItem}
      footer={footer}
      items={items}
      trigger={<div data-test-specifier="product environment menu">{trigger}</div>}
      popoverProps={rest}
    />
  );
};
